import { render } from "./OldXmlandFileDifMenu.vue?vue&type=template&id=6544a8d7&scoped=true"
import script from "./OldXmlandFileDifMenu.vue?vue&type=script&lang=js"
export * from "./OldXmlandFileDifMenu.vue?vue&type=script&lang=js"

import "./OldXmlandFileDifMenu.vue?vue&type=style&index=0&id=6544a8d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6544a8d7"]])

export default __exports__